"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AdditionalInformationItem_1 = __importDefault(require("@features/ItemCommon/components/common/AdditionalInformationItem"));
var react_i18next_1 = require("react-i18next");
var formatter_1 = require("@utils/formatter");
function ItemPriceReadOnly(_a) {
    var contentPrice = _a.contentPrice, priceCurrency = _a.priceCurrency, remoteIdDomain = _a.remoteIdDomain, angularJsDependencies = _a.angularJsDependencies, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null, contentPrice && contentPrice > 0 ? (react_1.default.createElement(AdditionalInformationItem_1.default, { titleTranslationKey: "", label: "".concat(t('ITEM.PRICE'), " (").concat(priceCurrency, ")"), angularJsDependencies: angularJsDependencies, value: String((0, formatter_1.thousandSeparator)(contentPrice)), renderTag: "span", domain: remoteIdDomain, automationListsPermission: automationListsPermission })) : null));
}
exports.default = ItemPriceReadOnly;
